export default angular
    .module('syBindFile', [])
    /**
     * @ngdoc directive
     * @name syBindFile.directive:syBindFile
     * @description
     * Creates a controller to track a file input with the ngModel.
     */
    // @ngInject
    .directive('syBindFile', [
        function () {
            return {
                require: 'ngModel',
                link: function (scope, $element, attrs, ngModel) {
                    $element.bind('change', function () {
                        scope.$apply(function () {
                            ngModel.$setViewValue($element.val())
                            ngModel.$render()
                        })
                    })
                }
            }
        }
    ])
